<div *ngFor="let doc of documents">
  <div class="p8-bdc_document__item" (click)="download(doc)">
    <i class="fa {{getPicto(doc)}}" aria-hidden="true"></i>&nbsp;
    {{doc?.title}}
  </div>
</div>

